import Header from "./header";
import Content from "./content";

export const AgendaResource = {
	Header: Header,
	Content: Content,
}
